import { colors, s32 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { text1 } from '@ardoq/typography';
import { getWeekDaysShortEu, getWeekDaysShortUs } from '../consts';
import { Locale, locales } from '@ardoq/locale';
import { FlexBox } from '@ardoq/layout';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale } from '@ardoq/i18n';

const DayHeader = styled.span`
  text-align: center;
  ${text1};
  color: ${colors.textSubtle};
  width: ${s32};
`;

type DayGridHeaderProps = {
  readonly locale?: Locale;
  readonly i18nLocale?: I18nLocale;
};

export const DayGridHeader = ({
  locale,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: DayGridHeaderProps) => {
  /*
    Instead of relying on user's locale to dynamically recognise US/EU format,
    we have few examples shown in Storybook where locale prop is passed in config.
    Based on config the DayGridHeader is updated
  */
  const weekDays =
    locale?.code === locales.enUS.code
      ? getWeekDaysShortUs(i18nLocale)
      : getWeekDaysShortEu(i18nLocale);

  return (
    <FlexBox gap="xsmall">
      {weekDays.map(day => (
        <DayHeader key={day}>{day}</DayHeader>
      ))}
    </FlexBox>
  );
};
